import React, {useContext} from 'react';
import {styled} from '@volkswagen-onehub/components-core';
import {Filter as FilterIcon} from '@volkswagen-onehub/icons-core';
import {InteractionLayerSizeV2, ShimBackgroundTypeV2} from '@volkswagen-onehub/layer-manager';
import {getTranslations} from '../translations';
import {LayerContext, useInteractionLayer} from '../Layers';
import FilterMenu from '../FilterPanel';

const StyledButton = styled.button<{active: boolean}>`
  display: flex;
  gap: 8px;
  -moz-box-pack: center;
  justify-content: center;
  -moz-box-align: center;
  align-items: center;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  padding: 8px 12px;
  transition: background 300ms, color 300ms;
  color: rgb(0, 30, 80);
  background: rgb(255, 255, 255);
  border: 1px solid rgb(194, 202, 207);
  :hover:not(:disabled) {
    box-shadow: rgb(194, 202, 207) 0px 0px 0px 1px inset;
  }
  :not(:hover) {
    transition: box-shadow 300ms;
  }
  :focus-visible {
    outline: rgb(0, 176, 240) solid 2px;
  }

  ${({ active }) => active ? `
    color: rgb(0, 64, 197);
    border: 2px solid rgb(0, 64, 197);
  ` : null }
`;

const CustomText = styled.span`
  margin-top: 0px;
  color: inherit;
  margin: unset;
  margin-top: unset;
  font-family: vw-text, Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-size: 0.88rem;
  line-height: 120%;
  letter-spacing: calc(-0.02em + 0.02rem);
  ::first-letter {
    text-transform: uppercase;
  }
`;

export const MoreFiltersButton = () => {
  const {labels} = getTranslations();
  const {closeLayer, isLayerOpen} = useContext(LayerContext);

  const openFiltersLayer = useInteractionLayer('filters-layer', {
    size: InteractionLayerSizeV2.C,
    onClose: () => closeLayer('filters-layer'),
    shimBackgroundType: ShimBackgroundTypeV2.OPAQUE
  });

  const handleClick = () => {
    openFiltersLayer((close) => <FilterMenu close={close} />);
  };

  return (
    <StyledButton onClick={handleClick} active={isLayerOpen('filters-layer')}>
      <FilterIcon variant="small" />
      <CustomText>{labels.show_filters}</CustomText>
    </StyledButton>
  );
};
